module.exports = __webpack_public_path__ + "static/media/Logo_totalplay.3e14621c.png";